module.exports = __webpack_public_path__ + "img/home-studio-2.a44c5c57.png";